<template>
  <aw-password-change-form
    :form-id="formId"
    :user-hash="userHash"
    :is-modal="false"
    @success="onSuccess"
  >
    <template #heading>
      <lv-heading tag="h1" level="1" version2>
        {{ $awt('aw.password_change.title') }}
      </lv-heading>
    </template>
    <template #buttons="{ validator }">
      <div>
        <aw-form-button :model-value="validator" shrink styling="primary-dark">
          {{ $awt('aw.password_change.submit') }}
        </aw-form-button>
      </div>
    </template>
  </aw-password-change-form>
</template>

<script setup lang="ts">
  import { navigateTo, useId, useNuxtApp, useRoute } from 'nuxt/app';
  import { LvHeading } from '~~/common/components/loginet-vue-shop/index';
  import AwFormButton from '~~/common/components/Form/AwFormButton.vue';
  import AwPasswordChangeForm from '~~/shop/app/components/AwPasswordChangeForm.vue';

  defineOptions({
    name: 'PasswordChangePage',
  });

  const { $localePath } = useNuxtApp();

  const userHash = String(useRoute().params.hash);

  const formId = useId();

  function onSuccess () {
    navigateTo($localePath('/'));
  }
</script>
